import React from 'react';

const SingleMetricChart = ({data, config = {}, rootCauseMetric = false}) => {
  const {
    title = "Time Series Chart",
    timestampKey = "timestamp",
    valueKey = "value",
    timestampFormat = 'time',
    yAxisLabel = "Value",
    height = "400px",
    color = '#7af8a9',
    spikedIndexes = []
  } = config;

  // Define different styling based on rootCauseMetric
  const chartColor = rootCauseMetric ? '#fdc8a3' : color; // Orange for root cause
  const containerClass = rootCauseMetric
    ? "w-75 bg-gray-900 rounded-lg shadow-xl border-2 border-orange-500"
    : "w-100 bg-gray-900 rounded-lg shadow-xl";

  // Timestamp formatting function
  const formatTimestamp = (epoch) => {
    const date = new Date(epoch * 1000);

    switch (timestampFormat) {
      case 'date':
        return date.toLocaleDateString();
      case 'datetime':
        return date.toLocaleString();
      case 'time':
      default:
        return date.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        });
    }
  };

  const formattedData = data?.map((item, index) => ({
    ...item,
    formattedTimestamp: formatTimestamp(item[timestampKey]),
    isSpiked: spikedIndexes.includes(index) // Mark spike based on backend data
  }))

  // Custom dot rendering function
  const renderDot = (props) => {
    const {cx, cy, stroke, fill, r, payload} = props;
    const isSpiked = payload.isSpiked;

    const dotColor = isSpiked ? '#fb5c5c' : (rootCauseMetric ? chartColor : fill);
    const dotSize = isSpiked ? 4 : (rootCauseMetric ? 4 : 4);

    return (
      <circle
        cx={cx}
        cy={cy}
        r={dotSize}
        stroke={isSpiked ? '#fb5c5c' : stroke}
        fill={dotColor}
        strokeWidth={rootCauseMetric ? 2 : 2}
      />
    );
  };

  // Custom tooltip
  const CustomTooltip = ({active, payload, label}) => {
    if (active && payload && payload.length) {
      return (
        <div className={`bg-gray-800 border ${rootCauseMetric ? 'border-orange-500' : 'border-gray-700'} shadow-lg rounded-md p-2`}>
          <p className="font-bold text-gray-200">{label}</p>
          <p style={{color: payload[0].color}}>
            {payload[0].value.toFixed(2)}
            {rootCauseMetric ? <span className="ml-2 mx-1 text-orange-500 font-bold"> ⚠️ Root Cause</span> :
              <span className="ml-2 mx-1 text-orange-500 font-bold"> ⚠️</span>}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div
      className={containerClass}
      style={{height: height}}
    >
      {/*{rootCauseMetric && (*/}
      {/*  <div className="bg-orange-500 bg-opacity-10 text-orange-500 font-bold text-center mt-1 pt-2 rounded-t-lg">*/}
      {/*  </div>*/}
      {/*)}*/}
      <ResponsiveContainer width="100%" height={rootCauseMetric ? "85%" : "90%"}>
        <LineChart
          data={formattedData}
          margin={{
            top: 10,
            right: 30,
            left: 20,
            bottom: 40
          }}
        >
          <CartesianGrid
            strokeDasharray={rootCauseMetric ? "5 2" : "3 3"}
            stroke={rootCauseMetric ? "#4b371e" : "#374151"}
          />
          <XAxis
            dataKey="formattedTimestamp"
            label={{
              value: 'Time',
              position: 'insideBottom',
              offset: -30,
              fill: '#9ca3af'
            }}
            interval="preserveStartEnd"
            angle={-30}
            textAnchor="end"
            tick={{fill: '#9ca3af', fontSize: 10}}
          />
          <YAxis
            label={{
              value: yAxisLabel,
              angle: -90,
              position: 'insideBottomLeft',
              fill: '#9ca3af'
            }}
            tick={{fill: '#9ca3af', fontSize: 8}}
          />
          <Tooltip
            content={<CustomTooltip/>}
            cursor={{stroke: '#4b5563', strokeWidth: 2}}
          />
          <Line
            type="monotone"
            dataKey={valueKey}
            stroke={chartColor}
            strokeWidth={rootCauseMetric ? 3 : 2}
            dot={renderDot}
            activeDot={{r: rootCauseMetric ? 6 : 4, strokeWidth: rootCauseMetric ? 3 : 2}}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine} from 'recharts';

export default SingleMetricChart;